export const parse = (
  text: string,
  userVariablesGroupsValues: Map<string, string | boolean> = new Map(),
  exampleVariablesGroupsValues: Map<string, string> = new Map(),
  cssClass: string = "",
) => {
  const regex =
    /<variable class="cdx-inline-tool-variable" data-group-id="([0-9, A-z, -]*)" data-variable-id="([0-9, A-z, -]*)">((?!variable).)*<\/variable>/g;

  const result = text.matchAll(regex);
  let newText = text;

  for (const matchs of result) {
    const key = `${matchs[1]}-${matchs[2]}`;
    let newValue = "";
    if (userVariablesGroupsValues.has(key)) {
      newValue = withAttributes(
        { cssClass, groupId: matchs[1], variableId: matchs[2] },
        userVariablesGroupsValues.get(key),
      );
    } else if (exampleVariablesGroupsValues.has(key)) {
      newValue = withAttributes(
        { cssClass, groupId: matchs[1], variableId: matchs[2] },
        withItalic(exampleVariablesGroupsValues.get(key)),
      );
    }

    newText = newText.replace(matchs[0], newValue);
  }

  return newText;
};

const withAttributes = (
  attributes: { cssClass: string; groupId: string; variableId: string },
  value: string | boolean,
) =>
  `<span class="${attributes.cssClass}" data-group-id="${attributes.groupId}" data-variable-id="${attributes.variableId}">${value}</span>`;
const withItalic = (value: string) => `<i class="example"><span class="example-marker">{</span>${value}<span class="example-marker">}</span></i>`;
